/**
 * UI Text Constants
 * Centralized location for all user-facing text, error messages, and labels
 */

// UI Text Constants
export const UI_TEXT = {
  TITLES: {
    DEFINE_AUDIENCE: 'Define Audience',
    COMPANY_INPUT_QUESTION: 'What company or product do you want to build an audience for?',
    REVIEW_RESEARCH: 'Review Research',
    REVIEW_SEGMENTS: 'Review & Refine Segments',
    REVIEW_PERSONAS: 'Review Sample Persona',
    FINALIZE_AUDIENCE: 'Name Your Audience',
    NAME_AUDIENCE_QUESTION: 'What would you like to name your audience?',
    SEGMENT_DISTRIBUTION: 'Segment Distribution',
    THANK_YOU: 'Successfully Submitted',
    AUDIENCE_CREATED: 'Perfect! Your audience is ready.',
    CREATING_AUDIENCE: 'Creating your audience...',
    PROCESSING_REQUEST: 'Processing your request...',
    STELLA: 'Stella',
    DEMOGRAPHICS: 'Demographics',
    BASIC_INFO: 'Basic Information',
    SHOPPING_PROFILE: 'Shopping Profile',
    PSYCHOGRAPHICS: 'Psychographics',
    PERSONALITY_TRAITS: 'Personality Traits (Big Five)',
    INTERESTS: 'Interests',
    GOALS: 'Goals',
    PAIN_POINTS: 'Pain Points',
    BEHAVIORS: 'Behaviors',
    VALUES: 'Values',
    MOTIVATORS: 'Motivators',
    DECISION_STYLE: 'Decision Making Style',
    BEHAVIORS_NEEDS: 'Behaviors & Needs',
    EXPECTED_OUTCOMES: 'Expected Outcomes',
    DECISION_CRITERIA: 'Decision Criteria',
    MARKETING_INSIGHTS: 'Marketing Insights',
    HUMAN_CHAOS: 'Human Chaos & Real Behavior',
    CUSTOMER_INSIGHTS: 'Customer Profile Insights',
    SEGMENT: 'Segment',
    TOTAL: 'Total',
    RESEARCH: 'Research',
    COMPETITORS: 'Competitors',
    SIMILARITIES: 'Similarities',
    DIFFERENCES: 'Differences',
    SEGMENTATION_PREFERENCES: 'Segmentation Preferences',
  },
  SUBTITLES: {
    DEFINE_TARGET_SCOPE: 'Define your simulation target and scope',
    COMPANY_INPUT_DESC: 'Share your website URL below',
    REVIEW_ANALYSIS: "Let's review our analysis and make any needed adjustments",
    REVIEW_SEGMENTS: "Let's review the customer segments identified for your audience",
    REVIEW_PERSONA: 'Give feedback on a sample persona for your audience',
    ADJUST_SEGMENTS:
      'Adjust the percentage of each segment in your final audience. The total must equal 100%.',
    NAME_AUDIENCE_DESC: 'Choose a memorable name that describes your target audience',
    SUCCESS_MESSAGE: 'Your audience build request has been submitted successfully.',
    SUCCESS_MESSAGE_FREE: 'Your audience has been saved to your account and is ready to use.',
    COMPLETION_NOTICE: "We'll email you when it's ready within 24-48 hours.",
    COMPLETION_NOTICE_FREE: 'Start testing ideas with your audience',
    SEGMENTATION_DESC: 'Tell us about your preferences',
  },
  BUTTONS: {
    CONTINUE: 'Continue',
    BACK: 'Back',
    VIEW_MORE: 'View more details',
    SHOW_LESS: 'Show less',
    BUILD_AUDIENCE: 'Build My Audience',
    BACK_TO_HOME: 'Back to Home',
    START_SIMULATING: 'Simulate',
    CLOSE: 'Close',
    GO_BACK: 'Go Back',
    SHOW_PASSWORD: 'Show password',
    HIDE_PASSWORD: 'Hide password',
  },
  PLACEHOLDERS: {
    COMPANY_INPUT: 'e.g., www.amazon.com or www.purina.com/dogs/dog-treats/dental-chews',
    SEGMENTS_FEEDBACK: 'Type your feedback about the segments...',
    PERSONA_FEEDBACK: 'Type your feedback about this persona...',
    RESEARCH_FEEDBACK: 'Type your feedback about the research...',
    AUDIENCE_NAME: 'E.g., Enterprise Tech Decision Makers Q3 2025',
  },
  LOADING: {
    SEGMENTS: 'Loading segments...',
    PERSONA: 'Loading persona...',
    RESEARCH: 'Loading research data...',
    AUDIENCE_DATA: 'Loading audience data...',
    REGENERATING: 'Regenerating...',
    REGENERATING_SEGMENTS: 'Regenerating segments...',
    REGENERATING_PERSONA: 'Regenerating persona...',
    REGENERATING_RESEARCH: 'Regenerating research...',
    PROCESSING: 'Processing...',
    SAVING: 'Saving...',
    SUBMITTING: 'Submitting...',
    BUILDING: 'Building...',
    TIME_ESTIMATE: 'This may take a few minutes',
  },
  PROGRESS: {
    GENERATING_PERSONAS: 'Preparing your audience data...',
    PREPARING_DATABASE: 'Preparing to save your audience...',
    SAVING_TO_DATABASE: 'Saving audience to your account...',
    ALMOST_COMPLETE: 'Almost ready...',
    CREATING_AUDIENCE: 'Creating Your Audience',
    PROGRESS_UPDATE: "We'll email you when it's ready within 10-30 minutes.",
  },
  LABELS: {
    MARKETING_APPROACH: 'Marketing Approach:',
    KEY_CHARACTERISTICS: 'Key Characteristics:',
    CURRENT_CUSTOMERS: 'Current Customers:',
    POTENTIAL_CUSTOMERS: 'Potential Customers:',
    AGE_RANGE: 'Age Range:',
    INCOME: 'Income:',
    EDUCATION: 'Education:',
    INDUSTRY: 'Industry:',
    JOB_FUNCTION: 'Job Function:',
    ROLE_LEVEL: 'Role Level:',
    TRIGGERS_MOTIVATIONS: 'Triggers & Motivations',
    EXPECTED_OUTCOMES: 'Expected Outcomes',
    CONCERNS_OBSTACLES: 'Concerns & Obstacles',
    DECISION_CRITERIA: 'Decision Criteria',
    PATH_TO_PURCHASE: 'Path to Purchase',
    PERCENTAGE_OF_AUDIENCE: '% of audience',
    TARGET_SEGMENT: 'Target Segment',
    PRIMARY_SEGMENT: 'Primary Segment',
    PERSONAS: 'personas',
    CORE_MOTIVATION: 'Core Motivation:',
    MESSAGE_STYLE: 'Message Style:',
    TRUST_SOURCES: 'Trust Sources:',
    EMOTIONAL_TRIGGERS: 'Emotional Triggers:',
    CONTRADICTIONS: 'Contradictions:',
    REAL_LIFE_MOMENTS: 'Real Life Moments:',
    AGE: 'Age:',
    GENDER: 'Gender:',
    ROLE: 'Role:',
    INCOME_LABEL: 'Income:',
    EDUCATION_LABEL: 'Education:',
    COMPANY: 'Company:',
    TENURE: 'Tenure:',
    ANNUAL_SPEND: 'Annual Spend (USD):',
    SHOPPING_INTENSITY: 'Shopping Intensity:',
    PRIMARY_DEVICE: 'Primary Device:',
    OPENNESS: 'Openness:',
    CONSCIENTIOUSNESS: 'Conscientiousness:',
    EXTRAVERSION: 'Extraversion:',
    AGREEABLENESS: 'Agreeableness:',
    NEUROTICISM: 'Neuroticism:',
    CONCERNS_AND_OBSTACLES: 'Concerns & Obstacles:',
    TRUST_SIGNALS: 'Trust Signals:',
    BEHAVIORAL_RESISTANCE: 'Behavioral Resistance:',
    REACTION_TO_FAILURE: 'Reaction to Failure:',
    CONTRADICTION_PATTERNS: 'Contradiction Patterns:',
    REAL_MOMENTS: 'Real Moments:',
    SHOPPING_MOOD_STATES: 'Shopping Mood States:',
    LOCATION: 'Location:',
    OCCUPATION: 'Occupation:',
    JOB_TITLE: 'Job Title:',
    COGNITIVE_STYLE: 'Cognitive Style:',
  },
  FEEDBACK: {
    SHARE_GENERAL: 'Share your feedback to improve the results',
    SHARE_SEGMENTS: 'Share your feedback on these segments to improve the results',
    SHARE_PERSONA: 'Share your feedback on this persona to improve the results',
    SHARE_RESEARCH: 'Share your feedback on this research to improve the results',
    REGENERATING_SEGMENTS:
      "Thanks for your feedback! I'm regenerating the segments to incorporate your suggestions...",
    REGENERATING_PERSONA:
      "Thanks for your feedback! I'm regenerating this persona to incorporate your suggestions...",
    REGENERATING_RESEARCH:
      "Thanks for your feedback! I'm regenerating the research to incorporate your suggestions...",
    SUCCESS_SEGMENTS:
      "Perfect! I've regenerated the segments based on your feedback. The details have been updated to better match your requirements.",
    SUCCESS_PERSONA:
      "Perfect! I've regenerated this persona based on your feedback. The details have been updated to better match your requirements.",
    SUCCESS_RESEARCH:
      "Perfect! I've regenerated the research based on your feedback. The analysis has been updated to better match your requirements.",
    ERROR_SEGMENTS:
      "I'm sorry, there was an error regenerating the segments. Please try again or check your connection.",
    ERROR_PERSONA:
      "I'm sorry, there was an error regenerating the persona. Please try again or check your connection.",
    ERROR_RESEARCH:
      "I'm sorry, there was an error regenerating the research. Please try again or check your connection.",
  },
  SYSTEM: {
    TITLE: 'System Message',
    IMPOSSIBILITY: {
      TITLE: 'Information Unavailable',
      DEFAULT_EXPLANATION: 'This request cannot be fulfilled with the available information.',
      HELP_TEXT: 'To help me provide better results, please answer:',
    },
  },
  CONFIRMATION: {
    RESEARCH:
      "Please review the research above. If you'd like any changes or have additional insights, let Stella know in the chat!",
    BUSINESS_MODEL:
      'Please confirm the business model is correct. You can chat with Stella for feedback.',
    COMPETITORS:
      'Do these competitors look accurate? Copy your list of competitors in the chat to modify the details.',
    SEGMENTS:
      'Please review these segments. Use the chat to add additional details and regenerate the segments as needed.',
    PERSONAS:
      'Please review the sample persona for each segment below. Use the chat to give feedback about characteristics, goals, or any other details.',
    FINALIZE:
      'Please review your segment distribution above. Adjust the percentages as needed and make sure they add up to 100%.',
  },
  AUDIENCE_SCOPE: {
    QUESTION: 'Is this audience for all customers or a specific segment?',
    ALL_CUSTOMERS: 'All Customers',
    ALL_CUSTOMERS_DESC:
      'Profiles will reflect your entire customer base. You can segment them later if needed.',
    SPECIFIC_SEGMENT: 'A Specific Segment',
    SPECIFIC_SEGMENT_DESC:
      'e.g., "Procurement leaders in healthcare and Technology," "Gen Z buyers", etc.',
    DESCRIBE_SEGMENT: 'Describe your target segment',
    SEGMENT_PLACEHOLDER: 'E.g., Senior IT decision makers in Fortune 500 companies',
  },
  SIMULATION_TARGET: {
    QUESTION: 'What are we creating an audience for?',
    COMPANY: 'A Company',
    COMPANY_DESC:
      'Simulate how people respond to a brand or organization, you can always test on a segment of the audience later',
    PRODUCT: 'A Product',
    PRODUCT_DESC: 'Simulate reactions to a specific product, feature, or service',
  },
  WEBSITE_URL: {
    COMPANY_TITLE: 'What is your company website?',
    PRODUCT_TITLE: 'What is your product page URL?',
    COMPANY_DESC:
      "This helps us understand your company better. We'll analyze the content to create more accurate profiles.",
    PRODUCT_DESC:
      "This helps us understand your product better. We'll analyze the content to create more accurate profiles.",
    COMPANY_PLACEHOLDER: 'https://yourcompany.com',
    PRODUCT_PLACEHOLDER: 'https://yourcompany.com/product',
    COMPANY_LABEL: 'Company URL',
    PRODUCT_LABEL: 'Product URL',
  },
  COMPETITORS_INPUT: {
    TITLE: 'Who are your main competitors?',
    DESCRIPTION:
      'Help us understand your competitive landscape by adding competitor names you know.',
    COMPANY_LABEL: 'Company Name',
    COMPANY_PLACEHOLDER: 'e.g., Salesforce, HubSpot, Microsoft',
    ADD_BUTTON: 'Add Competitor',
    REMOVE_BUTTON: 'Remove',
    SKIP_MESSAGE: 'Please provide at least 3 competitors to continue.',
    MINIMUM_REQUIREMENT: 'Please add at least 3 competitors.',
    INVALID_NAMES: 'Please enter valid company names for all competitors.',
    EMPTY_NAMES: 'Please provide company names for all competitors or remove empty entries.',
  },
  DATA_UPLOAD: {
    HEADING: 'Do you have any customer data to share?',
    DESCRIPTION:
      'Share customer info like reviews, surveys, or CRM data to build a more accurate audience.',
    UPLOAD_LABEL: 'Upload customer data',
    UPLOAD_BUTTON: 'Upload a file',
    UPLOAD_HELPER: 'CSV, Excel, or text file with customer data (max 1MB)',
    INSIGHTS_LABEL: 'Additional customer insights',
    INSIGHTS_PLACEHOLDER:
      'Enter any additional information about your customers that might help us understand them better...',
  },
  QUESTIONNAIRE: {
    BUSINESS_MODEL: {
      DETECTED: 'Business Model:',
      EXPLANATION:
        "We'll ask you specific questions based on your business model to generate more targeted segments.",
    },
    STEP1: {
      TITLE: "Tell us which customer segments you'd like us to focus on?",
      DESCRIPTION: 'Which specific customer segments matter most to your business',
      PLACEHOLDER:
        'Examples: Moms with infants, Gen Z and Millennials, US pet owners in urban areas, CPG and D2C brands',
    },
    STEP2: {
      TITLE: 'How should we group them?',
      DESCRIPTION: 'Select how we should segment your audience',
      PLACEHOLDER: 'Examples: By motivation, category, life-stage, demographics, industry, etc.',
    },
    HELP_TEXT: {
      TIP_TITLE: 'Tip:',
      TIP_CONTENT:
        'Your responses will help us generate more relevant and focused customer segments. If you do not share anything, we will create the segments that are most relevant based on your data.',
    },
  },
  AUTH: {
    HUMAN_VERIFICATION: {
      TITLE: 'Quick check',
      MESSAGE: "Please confirm you're human to continue.",
      CANCEL: 'Cancel',
      LOAD_ERROR: 'Verification could not be loaded. Please refresh the page and try again.',
    },
  },
  HUMAN_SURVEY: {
    FRAUD_GATE: {
      GEO: {
        TITLE: 'Access check',
        MESSAGE:
          'This survey is open to respondents in the United States only. If you are using a VPN or proxy, please disable it and try again.',
        RETRY_BUTTON: 'Try again',
        CHECKING: 'Checking your connection…',
      },
      AUTOMATION: {
        TITLE: 'Unsupported browser',
        MESSAGE:
          "This survey can't be started in this browser. Please use a standard, up-to-date web browser (Chrome, Safari, Firefox, or Edge) without automation tools.",
      },
      CHALLENGE: {
        TITLE: 'Quick verification',
        MESSAGE: 'Please confirm you are human to continue.',
        VERIFYING: 'Verifying…',
        UNAVAILABLE:
          'Additional verification is required but is currently unavailable. Please try again later.',
        LOAD_ERROR: 'Verification could not be loaded. Please refresh the page and try again.',
      },
    },
    TITLES: {
      CREATE_SURVEY: 'Create Human Survey',
      BACK_TO_SURVEYS: 'Back to Surveys',
    },
    DESCRIPTIONS: {
      MAIN: 'Paste your survey questions below and our AI will parse them into an interactive conversational format.',
      SURVEY_NAME_HELP: 'Choose a name that helps you identify this survey later',
      QUESTIONS_HELP:
        'Enter each question on a new line. Our AI will automatically detect question types and create appropriate input fields.',
      GOAL_HELP: 'Help our AI understand the purpose of your survey for better question parsing.',
      CONTEXT_HELP: 'Provide any additional context that might help with question parsing.',
    },
    LABELS: {
      SURVEY_NAME: 'Survey Name',
      QUESTIONS: 'Survey Questions *',
      GOAL: 'Research Goal (Optional)',
      CONTEXT: 'Additional Context (Optional)',
      // Shared by the create form's live field and the edit surfaces' locked one, so the author
      // recognises the same control in the place they go to change it.
      GROUP_COUNT: 'Number of Groups',
    },
    PLACEHOLDERS: {
      SURVEY_NAME: 'e.g., Customer Satisfaction Survey Q4 2024',
      QUESTIONS: `Paste your survey questions here, one per line. For example:

What is your overall satisfaction with our product?
Which features do you use most frequently?
How likely are you to recommend us to a friend?
What improvements would you like to see?`,
      GOAL: 'e.g., Understanding user satisfaction with our mobile app',
      CONTEXT:
        'e.g., This survey is for existing customers who have used our product for at least 3 months',
    },
    BUTTONS: {
      PARSE_QUESTIONS: 'Parse Questions',
      PROCESSING: 'Processing Questions...',
      TRY_AGAIN: 'Try Again',
    },
    PROGRESS: {
      PROCESSING_TITLE: 'Processing Questions',
      PARSING_FAILED: 'Parsing Failed',
    },
    SESSION: {
      // Shown while a question's stimulus image is still loading; its answer options are
      // disabled until then, so a respondent can never rate an image they haven't seen.
      LOADING_STIMULUS: 'Loading the image — the options unlock once it appears.',
      // Shown in place of a MaxDiff claim's artwork when it fails to load. Silence here is what
      // makes a broken stimulus dangerous: the tile still enables and the ranking is still saved,
      // so a respondent has no way to tell they are judging text where a pack shot should be.
      ITEM_IMAGE_FAILED: 'Image unavailable',
      /**
       * Everything the survey-wide countdown says to a respondent (spec 35).
       *
       * Here rather than beside the logic that chooses between these lines, for the same reason
       * as every other string in this file: the researcher-facing product is translated and
       * re-worded from one place, and a respondent-facing line living in a `switch` is one
       * nobody editing the copy will ever find. `surveyTimer.ts` picks WHICH line; this is what
       * each of them says.
       */
      TIMER: {
        // The readout's own two labels. "Timer paused" outranks the digits — a frozen clock the
        // respondent cannot explain reads as a broken one.
        PAUSED: 'Timer paused',
        FINAL_MINUTE: 'Final minute',
        // Names the MM:SS digits for a screen reader, which cannot see the register change.
        SECONDS_REMAINING: (seconds: number) => `${seconds} seconds remaining`,
        // The calm register's label, above the final minute. Whole minutes only: it turns over
        // once a minute, and per-second precision here would re-render the respondent runtime
        // once a second for the last ten minutes of every timed survey.
        MINUTES_LEFT: (minutes: number) =>
          `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} left`,
        // Deliberately encouraging rather than warning at every mark: the countdown exists to
        // reduce abandonment by showing the end is close, not to rush anyone.
        NUDGES: {
          FIFTEEN_MINUTES: "You're making great progress — about 15 minutes left.",
          TEN_MINUTES: 'Almost there — only 10 minutes left.',
          FIVE_MINUTES: "Just 5 minutes left. Please keep going — you're nearly finished.",
          FINAL_MINUTE: "Last minute — finish the question you're on.",
          // The fallback for a mark with no line of its own, and the figure the welcome-back
          // greeting quotes. "About" hedges the number, never the deadline behind it.
          ABOUT_MINUTES: (minutes: number) =>
            `About ${minutes} ${minutes === 1 ? 'minute' : 'minutes'} left.`,
        },
        // Greets a respondent whose clock the server had paused while they were away, and says
        // why the number jumped. `remaining` is composed in rather than interpolated here: below
        // the final minute it stops quoting minutes at all rather than rounding within them.
        WELCOME_BACK: (remaining: string) =>
          `Welcome back — your timer paused while you were away. ${remaining}`,
        WELCOME_BACK_UNDER_A_MINUTE: 'Less than a minute left.',
      },
      TITLES: {
        SURVEY_SESSION: 'Survey Session',
        SURVEY_NOT_FOUND: 'Survey Not Found',
        // Heads the card a respondent sees when the survey-wide limit runs out while the runtime
        // is between questions. Deliberately NOT the generic "Survey Unavailable" heading beside
        // it: nothing is broken, their time simply ran out, and the card it used to borrow came
        // with a "Go Home" button that walked them out of a session that was about to complete —
        // past the panel redirect they are credited by.
        TIME_UP: "Time's up",
      },
      DESCRIPTIONS: {
        LOADING: 'Loading survey...',
        NOT_FOUND: 'This survey session could not be loaded.',
        // Names the spinner on the time-up card for a screen reader. The wait is the whole
        // interaction there — the hard stop is landing behind it — so an unnamed spinner is the
        // one thing on that screen a respondent cannot perceive.
        CLOSING_OFF: 'Closing your survey off.',
      },
      // The welcome screen a respondent lands on, used only when the survey author left these
      // fields blank. Deliberately says nothing about AI: naming the moderator as a machine
      // primes a respondent before they have answered anything, and how their words are
      // processed is disclosed on the consent screen that follows, where it belongs.
      WELCOME: {
        DESCRIPTION:
          "Thanks for taking the time to participate in this survey. We'd love to hear your honest thoughts and opinions. There are no right or wrong answers.",
        INSTRUCTIONS:
          'You can answer using voice or text and switch between them at any time. If using voice, find a quiet place where you can speak clearly.',
      },
      LABELS: {
        SESSION_ID: 'Session ID:',
        STATUS: 'Status:',
        RESPONSES: 'Responses:',
      },
      // The bridge between the last answer and the completion redirect (spec 47): covers the
      // /complete round trip, whether the AI follow-up poll ahead of it or the completion call
      // itself is what's taking a while. Deliberately silent about which — the respondent has no
      // use for that distinction, only for being told not to close the page.
      FINISHING: {
        TITLE: 'Finishing up…',
        BODY: "Please don't close this page — we're saving your survey.",
      },
      BUTTONS: {
        COMPLETE_SESSION: 'Complete Session',
        COMPLETING: 'Completing...',
        BACK_TO_SURVEYS: 'Back to Surveys',
        GO_HOME: 'Go Home',
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        SUBMITTING: 'Submitting...',
        COMPLETE_SURVEY: 'Complete Survey',
        // Retry affordance on the finishing screen once /complete has exhausted its retries —
        // the respondent's own way to ask the same resilient call to run again.
        FINISH_SURVEY: 'Finish survey',
      },
      MESSAGES: {
        LONG_WAIT_HEADLINE: 'This is taking a little longer than usual',
        LONG_WAIT_DETAIL: "We're still working on your next question. Please keep this page open.",
        ANALYZING_RESPONSE: [
          '🪄 Reading between the lines...',
          '🧠 Thinking deeply about your response...',
          '💭 Analyzing your thoughts...',
          '✨ Processing your answer...',
          '🎯 Understanding your perspective...',
          '🤔 Reflecting on what you shared...',
          '💡 Connecting the dots...',
          '🧩 Piecing together the puzzle...',
          '🔬 Examining your response closely...',
          '🎪 Unpacking all the details...',
          '🌊 Diving deep into your answer...',
          '🚀 Exploring your perspective...',
          '🌙 Contemplating your thoughts...',
        ],
        LISTENING: 'Listening...',
        NO_SIGNAL_YET: "We can't hear you yet — check your microphone isn't muted",
        // Heads the amber panel that carries the reason a photo could not be used. Attributing
        // that verdict to "AI" told the respondent who judged them, not what to do next.
        PHOTO_REVIEW_NOTE: 'Note:',
        CONVERTING_SPEECH: 'Converting speech to text...',
        TAP_TO_SPEAK: 'Tap to speak your answer',
        VOICE_CONVERTED: 'Your voice will be converted to text automatically',
        RECORDING_TAP_AGAIN: 'Recording... Tap the microphone again when finished',
        PROCESSING_SPEECH: 'Processing your speech...',
        MIC_WARMING: 'Getting your microphone ready…',
        TYPE_YOUR_ANSWER: 'Type your answer',
        YOUR_RESPONSE: 'Your response:',
        SWITCH_TO_TEXT: 'Switch to text input',
        SWITCH_TO_VOICE: 'Switch to voice input',
        // Shown while a follow-up question is held back waiting for the spoken answer it would
        // probe (ADR-0005). Says what is happening to THEIR answer, not what the AI is doing.
        AWAITING_TRANSCRIPT: 'One moment — just getting your last answer.',
        // Why the mic will not start a take while the previous one is still saving (ADR-0011).
        SAVING_LAST_ANSWER: 'Saving your last answer…',
      },
      PLACEHOLDERS: {
        OPEN_ENDED: 'Type your answer here...',
        OTHER_SPECIFY: 'Please specify...',
      },
      CHOICES: {
        OTHER: 'Other',
        NONE_OF_THESE: 'None of these',
      },
      ERRORS: {
        TRANSCRIPTION_EMPTY:
          "We couldn't hear anything in that last recording, so nothing was added. Anything recorded before it is in the box below — you can carry on typing, or switch back to the mic and try again.",
        TRANSCRIPTION_UNAVAILABLE:
          "Voice transcription isn't available right now, so we've switched you to typing. Your remaining answers can be typed in — sorry for the interruption.",
        ANSWER_NOT_CAPTURED: "Sorry — that answer didn't save correctly. Please enter it again.",
        // Past the deadline the backend accepts a write and records nothing, flagging it only
        // with `survey_timer_expired`. Silence there walked the respondent on to the next
        // question and let them keep answering into a void, so this says plainly that the last
        // answer did not save and that the survey is being closed for them.
        TIME_UP:
          "Time's up — this survey's time limit has been reached, so that last answer wasn't saved. We're closing things off for you now.",
        MIC_NOT_READY: "We couldn't start your microphone. You can type your answer instead.",
        RECORDING_TOO_SHORT: 'That recording was too short. Please speak for at least 2 seconds.',
        RECORDING_UNREADABLE:
          "That recording didn't come through. Please record your answer again, or type it instead.",
        NO_SOUND_DETECTED:
          "We couldn't hear anything in that recording. Check that your microphone isn't muted, then record again — or type your answer instead.",
        NO_SPEECH_HEARD:
          "We didn't catch any words in that recording. Please record your answer again, or type it instead.",
        RECORDING_FAILED: 'Recording failed. Please try again.',
        MIC_PERMISSION: 'Could not access microphone. Please check your permissions.',
        // Shown on the finishing screen once /complete has exhausted its retries (spec 47). Says
        // nothing about the backend's error body — that's an implementation detail the respondent
        // cannot act on — only what they can do next.
        COMPLETE_FAILED: "We couldn't finish your survey just now. Tap Finish survey to try again.",
      },
    },
    // Shared across the desktop QR panel, the phone upload page, the in-browser camera upload,
    // and the researcher results page — one badge, one vocabulary, so "still
    // analysing" can never be mistaken for "found nothing".
    PHOTO: {
      ANALYSING: 'Analysing…',
      NOT_ANALYSED: 'Not analysed',
      NO_PRODUCTS: 'Nothing relevant found',
      REJECTED_NO_REASON: "The photo couldn't be analysed",
      AI_NOTE: 'AI note',
      RESPONDENT_TEXT: 'Respondent wrote',
    },
    CONVERSATIONAL: {
      MIC_STOP_TITLE: 'Stop recording',
      MIC_START_TITLE: 'Hold the thought — tap to record',
      LISTENING_TAP_STOP: 'Listening… tap to stop',
      TRANSCRIBING: 'Transcribing…',
      TAP_MIC_PROMPT: 'Tap the mic and answer out loud',
      ANSWER_PLACEHOLDER:
        'Your answer appears here — you can edit it before sending, or just type.',
      SENDING: 'Sending…',
      SEND_ANSWER: 'Send answer',
      ERRORS: {
        TRANSCRIBE_FAILED: 'Failed to transcribe audio. You can type your answer instead.',
      },
    },
    LIST: {
      TITLES: {
        HUMAN_SURVEYS: 'Human Surveys',
        NO_SURVEYS: 'No surveys yet',
      },
      DESCRIPTIONS: {
        MAIN: 'Create and manage your conversational surveys',
        NO_SURVEYS: 'Create your first human survey to get started.',
      },
      BUTTONS: {
        CREATE_SURVEY: 'Create Survey',
        CREATE_FIRST_SURVEY: 'Create Your First Survey',
        VIEW_DETAILS: 'View Details',
        TAKE_SURVEY: 'Take Survey',
        DUPLICATE: 'Duplicate',
        DUPLICATING: 'Duplicating…',
      },
      LABELS: {
        CREATED: 'Created',
        PUBLISHED: 'Published',
        SURVEY_NUMBER: 'Survey #',
      },
      LOADING: {
        LOADING: 'Loading surveys...',
      },
      ERRORS: {
        FAILED_TO_LOAD: 'Failed to load surveys',
        FAILED_TO_DUPLICATE: 'Could not duplicate the survey. Nothing was copied — try again.',
        FAILED_TO_DUPLICATE_GROUP:
          'Could not duplicate the survey group. Nothing was copied — try again.',
      },
      // Spec 42, PR 1: client-side search + state filter over the existing list.
      SEARCH: {
        PLACEHOLDER: 'Search surveys by name…',
        ARIA_LABEL: 'Search surveys by name',
        CLEAR_ARIA_LABEL: 'Clear search',
      },
      FILTERS: {
        ALL: 'All',
        ARIA_LABEL: 'Filter by state',
      },
      RESULTS: {
        SHOWING: (shown: number, total: number) => `Showing ${shown} of ${total}`,
        TOTAL: (total: number) => `${total} surveys and groups`,
      },
      // BOTH controls can narrow the list to nothing at once — a query with real matches
      // elsewhere, filtered to a state that excludes all of them. TITLE/BODY branch on
      // (query, stateLabel) together so that case reads "not in this state", never the
      // flatly false "no surveys match" (the survey exists; approved mock lines 279-280).
      // `stateLabel` is '' when the state filter is 'all', else the capitalized state name.
      NO_MATCH: {
        TITLE: (query: string, stateLabel: string) => {
          const q = query.trim();
          return q && stateLabel
            ? `No surveys match "${q}" in ${stateLabel}`
            : `No surveys match "${q || stateLabel}"`;
        },
        BODY: (query: string, stateLabel: string, total: number) =>
          query.trim() && stateLabel
            ? 'Nothing matches that name in this state. Try clearing the state filter.'
            : `Try a different name, or clear the filters to see all ${total}.`,
        CLEAR_FILTERS: 'Clear filters',
      },
    },
    QUESTIONS_PREVIEW: {
      TITLES: {
        REVIEW_QUESTIONS: 'Review',
      },
      DESCRIPTIONS: {
        REVIEW_HELP: 'Review and edit the questions below. Click on any question to modify it.',
        UNSAVED_CHANGES: 'You have unsaved changes',
        QUESTIONS_COUNT: (count: number) => `${count} question${count !== 1 ? 's' : ''} parsed`,
        FOLLOWUP_INSTRUCTIONS_HELP:
          "Provide specific instructions to guide the AI's follow-up questions",
      },
      BUTTONS: {
        SAVE: 'Save',
        CANCEL: 'Cancel',
        EDIT: 'Edit',
        ADD_CHOICE: '+ Add Choice',
        RE_ENTER_QUESTIONS: 'Re-enter Questions',
        CREATE_SURVEY: 'Create Survey',
        CREATING_SURVEY: 'Creating Survey...',
      },
      // Survey-wide countdown (spec 35). The respondent-facing side of this feature lives in
      // HUMAN_SURVEY.SESSION.TIMER; this is the researcher-facing authoring copy.
      TIMER: {
        SECTION_TITLE: 'Time Limit (Optional)',
        ENABLE_LABEL: 'Put this survey on a clock',
        ENABLE_HELP:
          'Respondents see nothing until the end is in sight, so a timer reads as reassurance ' +
          'rather than pressure. Warnings appear at 15, 10 and 5 minutes, then a live countdown ' +
          'in the final minute.',
        DURATION_LABEL: 'Duration',
        DURATION_SUFFIX: 'minutes',
        DURATION_PLACEHOLDER: 'e.g., 30',
        MODE_LABEL: 'When time runs out',
        MODE_GUIDANCE: 'Guidance — warn the respondent, but let them finish',
        MODE_HARD_STOP: 'Hard stop — end the session',
        MODE_HARD_STOP_HELP:
          'A hard stop counts from the moment the respondent opens the link, before the welcome ' +
          'and consent screens — so allow time for those. Answers submitted as the clock hits ' +
          'zero are still saved.',
      },
      LABELS: {
        ANSWER_CHOICES: 'Answer Choices',
        QUESTION_TEXT_PLACEHOLDER: 'Enter question text',
        FOLLOWUP_INSTRUCTIONS: 'AI Follow-up Instructions',
        FOLLOWUP_INSTRUCTIONS_PLACEHOLDER:
          'e.g., "If the user mentions price, ask about value for money"',
        ALLOW_OTHER_OPTION: 'Include "Other" option',
        ALLOW_NONE_OPTION: 'Include "None of these" option (unticks the others)',
        NONE_OPTION_DUPLICATE:
          'An option already says "None of these". Remove it, or respondents see it twice.',
        SIDE_BY_SIDE_CHOICES: 'Show options side by side',
        SIDE_BY_SIDE_UNMATCHED:
          "Shown as a list: give each option its own paragraph in the question, starting with the option's name.",
        STACK_PICTURE_CHOICES: 'Stack pictures in one column',
        CENTER_STATEMENT: 'Centre the statement (the last paragraph)',
        SLIDER_VALUE_PREFIX: 'Prefix',
        SLIDER_VALUE_PREFIX_PLACEHOLDER: 'e.g. $',
        OTHER_OPTION_INDICATOR: 'Other (with text input)',
        MAX_DIFF_ITEM_MEDIA: 'Item Image',
        MAX_DIFF_ITEM_MEDIA_FIRST_ONLY: 'Only the first image on a claim is shown to respondents.',
        MAX_DIFF_ITEM_MEDIA_IMAGE_ONLY:
          'A claim holds a video. MaxDiff claims show images only — respondents will see that claim as text with no picture. Replace it with an image.',
        // Shown only when a claim in a GROUPED survey still has an image on the shared sidecar —
        // the ordinary shape of a study that was illustrated before it was split into A/B. It is
        // served, so it has to be visible; it is fragile, so the condition is spelled out rather
        // than summarised as "shared".
        MAX_DIFF_ITEM_MEDIA_SHARED_IN_GROUPS:
          'This image is stored outside the A/B split. A group is shown it only while no claim in this question has an image of its own for that group — add one per group above, or remove this.',
        MAX_DIFF_DUPLICATE_CLAIMS:
          'Two or more claims have the same text. Respondents cannot tell them apart, they will share one image, and the balanced-set design counts them as a single claim. Make each claim unique.',
        // The near-miss is a DIFFERENT defect, so it gets a different note. Every runtime key is
        // the exact claim string — `choices.indexOf(item)` for the image, and maxDiffUtils'
        // per-item counters and pair keys for the design — so claims that differ by case or
        // spacing are two independent claims there, and saying they share an image or collapse
        // into one would be untrue. What IS true is that the respondent cannot tell them apart:
        // a trailing space is invisible in HTML, so two tiles in the same set can read identically
        // and still be scored as different claims.
        MAX_DIFF_LOOKALIKE_CLAIMS:
          'Two or more claims differ only in capitalisation or spacing. Respondents read them as the same claim, but they are stored separately — each takes its own image and its own place in the balanced-set design. Make each claim distinct.',
        // The per-group sidecar is resolved by REPLACING `option_media` wholesale
        // (`_build_questions_for_group`, backend#700), so the FIRST per-group image added to a
        // question un-illustrates every option that only has a shared one — for that group only,
        // and silently. Names the group and the options rather than describing the mechanism: the
        // researcher needs to know which half of their sample gets a blank tile.
        OPTION_GROUP_MEDIA_GAP: (groupLabel: string, optionLabels: string[]) =>
          `${groupLabel} respondents will see no image for ${optionLabels.map((label) => `"${label}"`).join(', ')}. ` +
          `Once any option in this question has a ${groupLabel} image, only options with their own ${groupLabel} image are illustrated for that group. ` +
          `Add a ${groupLabel} image to each of them, or remove the ${groupLabel} images from this question.`,
      },
      QUESTION_TYPES: {
        OPEN_ENDED_VOICE: 'Open-Ended (Voice)',
        SINGLE_CHOICE: 'Single Choice',
        MULTIPLE_CHOICE: 'Multiple Choice',
        YES_NO: 'Yes/No',
        RATING_SCALE: 'Rating Scale',
        LIKERT_SCALE: 'Likert Scale',
        RANKING: 'Ranking',
        SHORT_TEXT: 'Short Text',
        LONG_TEXT: 'Long Text',
        DROPDOWN: 'Dropdown',
        NPS: 'Net Promoter Score',
        NUMERIC_INPUT: 'Numeric Input',
        OPEN_ENDED: 'Open-Ended',
        MATRIX_GRID: 'Matrix Grid',
        QUALITATIVE: 'Qualitative',
      },
    },
    DETAILS: {
      TITLES: {
        SURVEY: 'Survey',
        SURVEY_NOT_FOUND: 'Survey not found',
        QUESTIONS: 'Questions',
        QUICK_ACTIONS: 'Quick Actions',
        SURVEY_INFO: 'Survey Info',
        SHARE_SURVEY: 'Share Survey',
      },
      DESCRIPTIONS: {
        NO_QUESTIONS: 'No questions have been added to this survey yet.',
        SHARE_HELP: 'Copy the link below to share your survey with respondents.',
      },
      BUTTONS: {
        BACK_TO_SURVEYS: 'Back to Surveys',
        PUBLISH: 'Publish',
        PAUSE: 'Pause',
        RESUME: 'Resume',
        SHARE: 'Share',
        VIEW_LIVE: 'View Live',
        SETTINGS: 'Settings',
        EDIT_QUESTIONS: 'Edit Questions',
        PREVIEW: 'Preview',
        VIEW_ANALYTICS: 'View Analytics',
        VIEW_RESPONSES: 'View Responses',
        COPY: 'Copy',
        // Spec 42 phase 5. Named for what they do, not just "Edit"/"Save": both detail screens
        // already carry an "Edit" and a "Save", and an ambiguous accessible name is how a click
        // lands on the wrong control.
        RENAME: 'Rename',
        SAVE_NAME: 'Save name',
        CANCEL_RENAME: 'Cancel rename',
      },
      LABELS: {
        SURVEY_NAME: 'Survey name',
        STATUS: 'Status',
        CREATED: 'Created',
        UPDATED: 'Updated',
        PUBLISHED: 'Published',
        QUESTIONS: 'Questions',
        SESSIONS: 'Sessions',
        RESPONSES: 'Responses',
      },
      LOADING: {
        LOADING: 'Loading survey...',
      },
      ERRORS: {
        FAILED_TO_LOAD: 'Failed to load survey details',
        FAILED_TO_UPDATE: 'Failed to update survey status',
        MUST_BE_ACTIVE: 'Survey must be active to share',
        NAME_REQUIRED: 'A survey needs a name — this is what you will search for later.',
        RENAME_FAILED:
          'Failed to rename the survey. The old name is still in place — please try again.',
      },
    },
    RESPONSES: {
      TITLES: {
        SURVEY_RESPONSES: 'Survey Responses',
        UNABLE_TO_LOAD: 'Unable to Load Responses',
        NO_RESPONSES: 'No Responses Yet',
      },
      DESCRIPTIONS: {
        VIEW_INDIVIDUAL: 'View individual responses from survey participants',
        NO_RESPONSES_YET:
          'Once participants complete the survey, their responses will appear here.',
      },
      BUTTONS: {
        BACK_TO_SURVEY: 'Back to Survey',
        VIEW_DETAILS: 'View Details',
      },
      LABELS: {
        COMPLETED_COUNT: (count: number) => `${count} completed`,
        IN_PROGRESS_COUNT: (count: number) => `${count} in progress`,
        ABANDONED_COUNT: (count: number) => `${count} abandoned`,
        TYPICAL_COMPLETION: 'Typical completion',
        TYPICAL_COMPLETION_UNAVAILABLE: 'N/A',
        TYPICAL_TIME: 'Typical Time',
        TYPICAL_TIME_HINT: (idleSeconds: number) =>
          `Median time respondents spent actively answering. Time with the tab hidden, the window in the background, or past ${idleSeconds}s without input is left out. "total" is the median from start to finish.`,
        ACTIVE_TIME_SUFFIX: 'active',
        TOTAL_TIME_SUFFIX: 'total',
        NO_TIME: '—',
        RESPONSE_NUMBER: (num: number) => `Response #${num}`,
        ANSWERS: (count: number) => `${count} answer${count !== 1 ? 's' : ''}`,
      },
      LOADING: {
        LOADING_RESPONSES: 'Loading responses...',
      },
      ERRORS: {
        FAILED_TO_LOAD_RESPONSES: 'Failed to load responses. Please try again.',
      },
    },
    SESSION_RESPONSES: {
      TITLES: {
        RESPONSE_DETAILS: 'Response Details',
        UNABLE_TO_LOAD_SESSION: 'Unable to Load Session',
        NO_RESPONSES_FOUND: 'No Responses Found',
      },
      DESCRIPTIONS: {
        COMPLETED_ON: 'Completed on',
        NO_SESSION_RESPONSES: 'This session does not contain any responses.',
      },
      BUTTONS: {
        BACK_TO_RESPONSES: 'Back to Responses',
      },
      LABELS: {
        SESSION_NUMBER: (id: number) => `Session #${id}`,
        QUESTION_NUMBER: (num: number) => `Q${num}`,
        NO_RESPONSE: 'No response',
        CONDITIONALLY_SKIPPED: 'N/A - Conditionally skipped',
        AI_FOLLOWUP: 'AI Follow-up',
        USER_RESPONSE: 'Response',
        CONVERSATION: 'Conversation',
        AI_ANSWERED: 'AI-answered',
        AI_ANSWERED_TOOLTIP:
          'This question was auto-answered by AI from earlier responses; the respondent did not see it.',
        AI_INFERRED_ANSWER: 'AI-inferred answer',
        AI_REASON: 'Why',
        AI_INFERRED_FROM: 'Inferred from',
        AI_CONFIDENCE: 'Confidence',
        // ai_dynamic_section has no authored question text (it writes its own questions each
        // turn) — matches the authoring UI's own wording (QuestionCard.tsx) rather than
        // inventing new copy, and replaces the generic "Unknown Question" fallback that text
        // otherwise falls through to.
        AI_DYNAMIC_SECTION_HEADING: 'Adaptive section — writes its own questions',
        AI_DYNAMIC_SECTION_QUESTION: 'AI asked',
        AI_DYNAMIC_SECTION_ANSWER: 'Respondent answered',
        AI_DYNAMIC_SECTION_STOP_REASONS: {
          timeout: 'Ended early — timed out before finishing',
          abandoned: 'Ended early — the respondent left before finishing',
          error: 'Ended early — a technical error stopped the interview',
        },
        // response.state values RESPONSE_STATES.TRANSCRIPTION_PENDING / TRANSCRIPTION_FAILED
        // (constants/interview_constants.py) — a rapid-fire voice answer written before its
        // transcript is back (still in flight, or both providers gave up). Distinct wording so
        // a researcher can tell "still coming" apart from "gone for good, but we kept the audio".
        VOICE_TRANSCRIPT_PENDING: 'Transcribing…',
        VOICE_TRANSCRIPT_PENDING_HINT: 'Voice recorded — text not yet available.',
        VOICE_TRANSCRIPT_FAILED: 'Transcription failed',
        VOICE_TRANSCRIPT_FAILED_HINT: 'Voice recorded — the transcript could not be recovered.',
        // A best/worst question whose stored answer is not the {best, worst} shape — a row saved
        // under an older spelling, or one that never finished. The raw value is shown beneath it
        // rather than hidden: what was actually stored is the thing worth seeing.
        BEST_WORST_UNREADABLE: 'Answer stored in an unrecognised format',
      },
      QUALITY_FLAGS: {
        RAPID_COMPLETION: 'Rapid Completion',
        VERY_SHORT_RESPONSE: 'Very Short Response',
      },
      QUALITY_DESCRIPTIONS: {
        RAPID_COMPLETION:
          'Response submitted very quickly, may indicate insufficient consideration',
        VERY_SHORT_RESPONSE: 'Response contains very few characters or words',
        QUALITY_ISSUES_DETECTED: 'Quality issues detected with this response',
      },
      LOADING: {
        LOADING_SESSION: 'Loading session details...',
      },
      ERRORS: {
        FAILED_TO_LOAD_SESSION: 'Failed to load session details. Please try again.',
      },
    },
    COMPLETE: {
      TITLES: {
        THANK_YOU: 'Thank You!',
        // Heads the same page when the survey-wide hard stop ended the session rather than the
        // respondent finishing it. Read together with TIMED_OUT below this is the spec's line —
        // "Time's up — thank you, your answers have been saved." — and it is deliberately not
        // framed as a failure: they answered in good faith and the researcher chose the limit.
        TIMED_OUT: "Time's up",
        SESSION_NOT_FOUND: 'Session Not Found',
      },
      MESSAGES: {
        SUCCESS: 'Your survey responses have been submitted successfully.',
        // The other half of that line. Says the thing a cut-off respondent actually needs to
        // know: the work they already did is safe. Without it they were shown a green tick and
        // "Your survey responses have been submitted successfully" — congratulated on completing
        // a survey they were stopped part-way through.
        //
        // Only ever shown for a stop the server CONFIRMED as a completion (`credited: true` on
        // the /timer/expire envelope). It is a claim about the database, and there are two ways
        // to reach this page without it being true.
        TIMED_OUT: 'Thank you — your answers have been saved.',
        /**
         * The same page when the session did NOT become a completion.
         *
         * Two ways here, and one line for both because the respondent's position is the same in
         * each: the survey is over for them and nothing has been recorded as finished.
         *
         * - The server granted the stop and answered `credited: false` — a hard stop is anchored
         *   on the session's own `created_at`, so a short one can run out while the respondent is
         *   still on welcome or consent, and a session that recorded nothing is retired rather
         *   than paid for.
         * - /timer/expire could never be reached at all (a 404, or ten failures in a row). The
         *   session stays `in_progress` until the abandonment sweep takes it.
         *
         * Neither carries a panel `redirect_url`, so a panel respondent is not credited — and
         * telling them their answers were saved is the one thing that stops them asking.
         */
        TIMED_OUT_UNCREDITED:
          "Your time ran out before this session could be completed, so it hasn't been recorded " +
          'as a finished response.',
        CLOSE_TAB: 'You can now safely close this tab or window.',
        SESSION_NOT_FOUND: 'This session could not be found.',
        LOADING: 'Loading...',
        FAILED_TO_LOAD: 'Failed to load session details.',
      },
      BUTTONS: {
        GO_HOME: 'Go Home',
      },
    },
  },
} as const;

// Utility function to get a random analyzing message
export const getRandomAnalyzingMessage = (): string => {
  const messages = UI_TEXT.HUMAN_SURVEY.SESSION.MESSAGES.ANALYZING_RESPONSE;
  const randomIndex = Math.floor(Math.random() * messages.length);
  return messages[randomIndex];
};

// Error messages
export const ERROR_MESSAGES = {
  INVALID_URL: 'Please enter a valid website URL (e.g., google.com or https://google.com)',
  REQUIRED_FIELD: 'This field is required',
  GENERIC: 'An unexpected error occurred. Please try again.',
  RESEARCH_NOT_FOUND: 'Research data not found. Please go back and generate research first.',
  SEGMENTS_NOT_FOUND: 'Segments data not found. Please go back and generate segments first.',
  NO_SEGMENTS_AVAILABLE: 'No segments available. Please go back and define segments first.',
  NO_PERSONAS_AVAILABLE: 'No personas available',
  NO_PERSONA_ID: 'Cannot regenerate persona: No persona ID available.',
  SEGMENT_INFO_UNAVAILABLE: 'Segment information not available',
  MISSING_AUDIENCE_DATA: 'Missing required audience data. Please complete Step 1 first.',
  AUDIENCE_NAME_REQUIRED: 'Please provide a name for your audience',
  SELECT_SIMULATION_TARGET: 'Please select a simulation target',
  SELECT_AUDIENCE_SCOPE: 'Please select an audience scope',
  DESCRIBE_TARGET_SEGMENT: 'Please describe your target segment',
  GENERATE_SEGMENTS_FAILED: 'Failed to generate segments. Please try again.',
  GENERATE_PERSONAS_FAILED: 'Failed to generate personas. Please try again.',
  REGENERATE_PERSONAS_FAILED: 'Failed to regenerate personas. Please try again.',
  SAVE_SEGMENTS_FAILED: 'Failed to save segments. Please try again.',
  SAVE_PERSONAS_FAILED: 'Failed to save personas. Please try again.',
  SUBMIT_AUDIENCE_FAILED: 'Failed to submit audience request. Please try again.',
  REFRESH_RESEARCH_FAILED: 'Failed to refresh research data. Please try again.',
  REGENERATE_RESEARCH_FAILED: 'Failed to regenerate research. Please try again.',
  GENERATE_RESEARCH_FAILED: 'Failed to generate research data. Please try again.',
  SEGMENTS_PERCENTAGE_TOTAL: (totalPercentage: number) =>
    `Segment percentages must add up to 100%. Current total: ${Math.round(totalPercentage)}%`,
  FILE_SIZE_EXCEEDED: (currentSize: number, maxSize: number) =>
    `File size exceeds ${maxSize}MB limit. Selected file is ${currentSize.toFixed(2)}MB.`,
} as const;
